import { queryOptions } from "@tanstack/react-query";
import { api, shownCompany, unwrap } from "@/client/lib/api";
import { takeEarly } from "@/client/lib/early-reads";
import { noteRead } from "@/client/lib/sync-cursor";
import type { ListedTask } from "@/features/tasks/schemas";

/** The working set, read whole once and filtered in memory by every task screen. */
export const tasksQuery = queryOptions({
  queryKey: ["tasks"],
  queryFn: async ({ client }): Promise<ListedTask[]> => {
    // Asked with the page for the session's company; used only if the guard settled there.
    const early = await takeEarly("tasks");
    const first =
      (early?.slug === shownCompany() ? early.page : null) ??
      (await unwrap(api.tasks.$get({ query: {} })));
    const items: ListedTask[] = [...first.items];
    let after = first.next;
    while (after) {
      const page = await unwrap(api.tasks.$get({ query: { after } }));
      items.push(...page.items);
      after = page.next;
    }
    // The first page's: a write landing between pages is caught by the next delta read.
    noteRead(client, first.cursor);
    return items;
  },
});
